export const generateStatusTabs = numberOfPossibleCalls => {
  const possibleCallsTabs = {}
  for (let i = 1; i <= numberOfPossibleCalls; i++) {
    possibleCallsTabs[i] = `call${i}`
  }

  return {
    0: 'notContacted',

    // dynamic number of Calls (1..10)
    ...possibleCallsTabs,

    11: 'recall',
    12: 'appointment',
    13: 'dropOff',
    14: 'notReached',
    15: 'successfullyReached'
  }
}

export const allowedContactFields = [
  {
    name: 'company',
    columnWidth: 200
  },
  {
    name: 'address',
    columnWidth: 200
  },
  {
    name: 'zip',
    columnWidth: 80
  },
  {
    name: 'city',
    columnWidth: 150
  },
  {
    name: 'phoneCentral',
    columnWidth: 120
  },
  {
    name: 'phoneDirect',
    columnWidth: 120
  },
  {
    name: 'email',
    columnWidth: 150
  },
  {
    name: 'salutation',
    columnWidth: 100
  },
  {
    name: 'firstName',
    columnWidth: 100
  },
  {
    name: 'lastName',
    columnWidth: 100
  },
  {
    name: 'function',
    columnWidth: 100
  },
  {
    name: 'comment',
    columnWidth: 100
  }
]



// WEBPACK FOOTER //
// ./src/helpers/index.js